/*** IMPORTS FROM imports-loader ***/
var loadTerrific = require("bootstrap/load-terrific");
var Tc = loadTerrific.default;
(function() {
var window = this;
var window = (window || {});
window.Tc = Tc;

(function(Accordion, $) {
	'use strict';

	function findPositioningParent($element) {
		var parent = $element.parent();
		while(parent.length && parent.css('overflow') !== 'hidden') {
			parent = parent.parent();
		}
		return parent;
	}

	// Searches the positioningParent’s height in accordance with some conventions
	function findHeight(heightParent) {
		var height = heightParent.find('[data-height]').data('height');
		if(!height) {
			height = heightParent.outerHeight();
		}
		return height;
	}

	/**
	 * Accordion full bleed skin
	 * Tries to take up as much vertical space as possible
	 *
	 * @author TAASCRAA
	 * @namespace Tc.Module.Accordion
	 * @class FullBleed
	 * @extends Tc.Module.Accordion
	 */
	Accordion.FullBleed = function(parent) {
		this.availableContentHeight = null;

		this.setupAccordion = function() {
			var heightParent = findPositioningParent(this.$ctx);
			if(heightParent.length) {
				this.availableContentHeight = findHeight(heightParent);
			}
			parent.setupAccordion.apply(this, arguments);
		};

		this.after = function() {
			parent.after.apply(this, arguments);
			if(!this.availableContentHeight) {
				return;
			}
			this.$ctx.css({
				position: 'absolute',
				top: 0,
				left: 0,
				bottom: 0,
				right: 0
			});
		};

		this.setupTab = function(index, tab) {
			parent.setupTab.apply(this, arguments);
			if(!this.availableContentHeight) {
				return;
			}
			tab = $(tab);
			var opener = tab.data(Accordion.DATA.TAB.OPENER);
			this.availableContentHeight -= opener.outerHeight();
		};

		this.tabOpened = function(tab) {
			parent.tabOpened.apply(this, arguments);
			if(!this.availableContentHeight) {
				return;
			}
			var panel = tab.data(Accordion.DATA.TAB.PANEL);
			var box = panel.outerHeight() - panel.height();
			panel.css({
				overflowY: 'auto',
				overflowX: 'hidden',
				height: ''+(this.availableContentHeight-box)+'px'
			});
		};

		// Diable scrolling the view on focus
		this.handleFocusOpener = $.noop;
	};

}(window.Tc.Module.Accordion, window.Tc.$));
}.call(window));


//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/modules/Tc.Module.Accordion.FullBleed.js
// module id = 129
// module chunks = 0